import { render, staticRenderFns } from "./CreateRestaurant.vue?vue&type=template&id=5ec9f579"
import script from "./CreateRestaurant.vue?vue&type=script&lang=js"
export * from "./CreateRestaurant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports